// TODO move to shared package
export const RepeatInterval = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
};

// TODO move to shared package
export const EmploymentType = {
  SALARIED: "salaried",
  CONTRACTED: "contracted",
};

export const CommuteType = {
  PUBLIC_TRANSPORT: "public-transport",
  PRIVATE_TRANSPORT: "private-transport",
};

export const UserType = {
  PERSON: "PERSON",
  COMPANY: "COMPANY",
  EMPLOYEE: "EMPLOYEE",
};

export const InputElementType = {
  COMPONENT: "component",
  DATE: "date",
  DATE_TIME: "date-time",
  NUMBER: "number",
  CHECKBOX: "checkbox",
  TEXT: "text",
  SELECT: "select",
};

export const InputElementSize = {
  S: "small",
  M: "medium",
  L: "large",
};

export const FormMode = {
  CREATE: "create",
  UPDATE: "update",
  VIEW: "view",
};

export const ReportRequiredByType = {
  NONE: "none",
  ONE: "one",
  ALL: "all",
};



// WEBPACK FOOTER //
// ./src/types/enums.js